import { LABEL_FONT, TEXT_FONT_SIZE } from '../../constants';
export const getFontStyles = ({ fontSize }) => ({
    font: LABEL_FONT,
    fontSize: `${fontSize || TEXT_FONT_SIZE}px`,
});
export const textContainsMultipleLines = (text) => Boolean((text !== null && text !== void 0 ? text : '').match(/[\n]/));
export const countTextRows = (text) => { var _a, _b; return ((_b = (_a = (text !== null && text !== void 0 ? text : '').match(/\n/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + 1; };
//# sourceMappingURL=utils.js.map